import { makeReduxActiveMessage } from 'main/factories/usecases/message/Update';

export const closeModal = (): void => {
  makeReduxActiveMessage().active({
    active: 'none',
  });
};
